import axios from 'axios';
import Account from '../models/SFModels/Account';

const API_URL =
  process.env.REACT_APP_ENV === 'local'
    ? `${process.env.REACT_APP_API_LOCAL}/salesforce/account`
    : process.env.REACT_APP_ENV === 'production'
      ? `${process.env.REACT_APP_API_PRODUCTION}/salesforce/account`
      : `${process.env.REACT_APP_API_STAGING}/salesforce/account`;

const accountApi = {
  fetchAccount(params) {
    return axios.get(`${API_URL}${params}`).then(response => {
      const { id, typoCategory, typoType, phone } = response.data;
      return new Account(id, typoCategory, typoType, phone);
    });
  },

  updateAccount(params, accountUpdated) {
    const body = JSON.stringify(accountUpdated);
    return axios
      .put(`${API_URL}?accountId=${params}`, body, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        return response.data;
      });
  },
};

export default accountApi;



// WEBPACK FOOTER //
// ./src/api/account.js